import { useEffect, useState } from "react";
import { ChevronDown, ShieldCheck } from "lucide-react";
import { api } from "../lib/api";

const PLATFORMS = [["هنقرستيشن", "#FFC72C", "#111"], ["كيتا", "#FFD400", "#111"], ["جاهز", "#E30613", "#fff"], ["نينجا", "#111827", "#fff"], ["تويو", "#7C3AED", "#fff"], ["مرسول", "#0EA5E9", "#fff"]];

const FAQ = [
  ["هل يمكنني تجربة النظام مجاناً؟", "نعم، تحصل على فترة تجريبية مجانية بكل المزايا دون الحاجة لبطاقة، ثم تختار الباقة المناسبة."],
  ["ما المنصات المدعومة؟", "هنقرستيشن وكيتا (طلبات وشرائح) ونينجا وجاهز وغيرها — مع لوحة موحّدة تقارن بين التطبيقات، ويمكن إضافة أي منصة جديدة بنفسك."],
  ["كيف تُحسب رواتب المناديب؟", "بنظام الهدف أو المسافة أو القوالب اليدوية، مع مقارنة تلقائية لأفضل خطة لكل مندوب وخصم السلف والمخالفات."],
  ["ما طرق الدفع والمدد المتاحة؟", "اشتراك شهري أو 3 أشهر (خصم 5%) أو سنوي (خصم 15%). الدفع إلكترونياً أو بالتحويل البنكي مع رفع الإيصال، ويُفعّل الاشتراك بعد المراجعة."],
  ["هل بياناتي آمنة؟", "كل شركة معزولة ببياناتها تماماً، مع صلاحيات دقيقة لكل مستخدم، وتحقق إضافي برمز PIN للعمليات الحساسة، ونسخ احتياطية."],
  ["هل يعمل على الجوال؟", "نعم، النظام سحابي ويعمل من المتصفح على كل الأجهزة، وللموظفين تطبيق خاص لطلب الإجازات وتوقيع القرارات ومتابعة الأداء."],
  ["هل يدعم الفوترة الإلكترونية ZATCA؟", "نعم، يصدر فواتير ضريبية برمز QR متوافقة مع المرحلة الأولى، ويُعمل على الربط المباشر للمرحلة الثانية."],
];

export const LandingTrust = () => {
  const [names, setNames] = useState([]);
  const [open, setOpen] = useState(0);
  useEffect(() => { api.billingOptions().then((r) => setNames(r.trusted_names || [])).catch(() => {}); }, []);
  return (
    <section className="bg-white px-4 py-16 sm:px-8" data-testid="landing-trust-section">
      <div className="mx-auto max-w-6xl space-y-14">
        <div className="text-center">
          <p className="mb-4 text-sm font-bold text-slate-500">المنصات المدعومة</p>
          <div className="flex flex-wrap justify-center gap-3" data-testid="landing-platforms">
            {PLATFORMS.map(([n, bg, fg]) => <span key={n} style={{ background: bg, color: fg }} className="rounded-2xl px-5 py-2.5 font-heading text-base font-extrabold shadow-sm transition-transform hover:-translate-y-0.5">{n}</span>)}
          </div>
        </div>
        {names.length > 0 && (
          <div className="text-center" data-testid="landing-trusted">
            <p className="mb-4 flex items-center justify-center gap-1.5 text-sm font-bold text-slate-500"><ShieldCheck className="h-4 w-4 text-emerald-600" /> موثوق به من قِبل</p>
            <div className="flex flex-wrap justify-center gap-2">{names.map((n) => <span key={n} className="rounded-xl border border-slate-200 bg-slate-50 px-4 py-2 text-sm font-semibold text-slate-700">{n}</span>)}</div>
          </div>
        )}
        <div className="mx-auto max-w-3xl" data-testid="landing-faq">
          <h2 className="mb-6 text-center font-heading text-2xl font-extrabold text-slate-900 sm:text-3xl">الأسئلة الشائعة</h2>
          <div className="divide-y divide-slate-100 rounded-2xl border border-slate-200">
            {FAQ.map(([q, a], i) => (
              <div key={q}>
                <button onClick={() => setOpen(open === i ? -1 : i)} className="flex w-full items-center justify-between gap-3 px-5 py-4 text-right font-semibold text-slate-800" data-testid={`landing-faq-q-${i}`}>
                  {q}<ChevronDown className={`h-4 w-4 shrink-0 text-slate-400 transition-transform ${open === i ? "rotate-180" : ""}`} />
                </button>
                {open === i && <p className="px-5 pb-4 text-sm leading-7 text-slate-600" data-testid={`landing-faq-a-${i}`}>{a}</p>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
